export const translations = {
  AL: {
    nav: {
      home: "Kreu",
      villa: "Vila",
      gallery: "Galeria",
      rooms: "Dhomat",
      activities: "Përvoja",
      contact: "Kontakt",
      book: "Rezervo",
    },
    hero: {
      eyebrow: "Jezerc - Ferizaj - Kosovë",
      title1: "Një botë qetësie",
      title2: " dhe elegance",
      desc: "Një Vill malore intime e mbështjellë me pamje relaksuese, e krijuar për mysafirë që e dinë se luksi i vërtetë është heshtja",
      explore: "Rezervo Vilën",
      book: "Rezervo Tani",
      pay: "Paguaj Online",
    },
    booking: {
      checkin: "Hyrje",
      checkout: "Dalje",
      guests: "Mysafirë",
      search: "Kontrollo Disponueshmërinë",
      adults: (n) => `${n} ${n === 1 ? "mysafir" : "mysafirë"}`,
    },
    about: {
      eyebrow: "Villa Delight",
      title: "Përjetoni një pushim me stil modern në zemër të maleve, freskohu në pishinë ku qetësia dhe natyra takohen",
      p1: "Villa Delight gjindet në fshatit Jezerc · Një villë e ndërtuar me stil modern, tavane të ulëta dhe dritare të gjera që kornizojnë heshtjen alpine",
      p2: "Çdo dhomë është projektuar si një pauzë një vend për relax, për të fjetur në qetësi dhe ajr të pastër, për të parë motin që ndryshon mbi luginë",
      p3: "Pa nxitim vetëm mali, ngrohtësia e një dhome dhe qetësia që mbetet",
      stat1: "5",
      stat1l: "Mysafirë",
      stat2: "2",
      stat2l: "Dhoma gjumi",
      stat3: "1.850m",
      stat3l: "Lartësia",
    },
    amenities: {
      eyebrow: "Çfarë ju pret",
      title: "Një qëndrim i mbushur me qetësi dhe dashuri",
      items: [
        { t: "Pishinë e jashtme", d: "Përjeto një freski dhe momente relaksuese gjat qëndrimit në pishinë" },
        { t: "Kamin", d: "Krijon një atmosferë të ngrohtë dhe relaksuese" },
        { t: "Kuzhinë Moderne", d: "E pajisur me detaje cilësore dhe komoditet të përditshëm" },
        { t: "Grill i Jashtëm", d: "Ideale për momente gatimi dhe darka në ajër të pastër" },
        { t: "Tarracë Panoramike", d: "Pamje të hapura dhe perëndime mbresëlënëse" },
        { t: "WiFi & TV", d: "Lidhje e shpejtë dhe argëtim kur ju nevojitet" },
        { t: "Parking Privat", d: "Akses i lehtë dhe hapësirë e dedikuar" },
        { t: "Dysheme me Ngrohje", d: "Komoditet i plotë në çdo hapësirë" },
        { t: "Kondicioner", d: "Temperaturë ideale në çdo stinë" },
      ],
    },
    gallery: {
      eyebrow: "Ditar Vizual",
      title: "Zhytuni në këtë hapësirë",
    },
    rooms: {
      eyebrow: "Çmimet",
      title: "Dy dhoma të mobiluara me stil modern dhe pishinë të jashtme",
      desc: "Në çmimet përfshihet vetëm akomodimi",
      items: [
        { name: "Villë Private me Pishinë", size: "72 m²", guests: "5 mysafirë", view: "Privatësi e plotë dhe ekskluzivitet absolut, një ambient për relaks dhe qetësi të vërtetë", price: "€ 150" },
      ],
      night: "/ nata",
      reserve: "Rezervo",
    },
    activities: {
      eyebrow: "Rreth Vilës",
      title: "Shijo çdo stinë",
      items: [
        { t: "Pishinë Malore", d: "Zhytu në freski, shijo qetësinë, përjeto magjinë." },
        { t: "Magjia e Dimrit", d: "Peizazhe të bardha, qetësi dimërore, magji nga dhjetori." },
        { t: "Rehati", d: "Shijoni gjumin e qetë, rehatinë e përsosur dhe ajrin e pastër malor." },
        { t: "Mbrëmja në Villa Delight", d: "Relaksohuni në qetësinë e maleve, të shoqëruar nga cicërimat e natyrës" },
      ],
    },
    reviews: {
      eyebrow: "Letra Mysafirësh",
      title: "Fjalë nga ata që qëndruan",
      items: [
        { q: "Pishina ishte fantastike, sidomos në mbrëmje. Shumë qetësi dhe privatësi për një pushim perfekt", a: "Arta & Erioni", loc: "Prizren" },
        { q: "Katër netët më të qeta të vitit. Nuk donim të largoheshim nga oxhaku", a: "Ana & Loriku", loc: "Prishtinë" },
        { q: "Villa Delight është një mjeshtëri e përmbajtjes. Çdo detaj i shërben qetësisë", a: "Gresa R.", loc: "Mitrovicë" },
        { q: "U zgjuam me borë në tarracë pamje e paharrueshme.", a: "Elena K.", loc: "Gjilan" },
        { q: "Një nga vilat më të pastra që kemi vizituar ndonjëherë", a: "Onat", loc: "Gjilan" },
        { q: "Shërbim i shkëlqyer dhe vend shumë relaksues për pushime", a: "Luan B.", loc: "Shkup" },
        { q: "Përvojë fantastike, vila ishte edhe më e bukur se në foto", a: "Sara L.", loc: "Tiranë" },
        { q: "Ambient shumë i pastër dhe i qetë, do të kthehemi përsëri", a: "Ardit M.", loc: "Prishtinë" },
        { q: "Një fundjavë perfekte larg zhurmës së qytetit. Ambienti ishte fantastik", a: "Erina & Besarti", loc: "Pejë" },
        { q: "Çdo gjë ishte menduar deri në detaj. Shumë komode dhe relaksuese", a: "Dion M.", loc: "Ferizaj" },
        { q: "Pamja nga vila në mëngjes ishte thjesht mahnitëse. Një eksperiencë që ia vlen", a: "Jona K.", loc: "Prizren" },
        { q: "Pastërti, qetësi dhe privatësi në nivelin më të mirë. Do të rikthehemi patjetër", a: "Valon H.", loc: "Gjakovë" },
        { q: "Vend ideal për disa ditë pushimi. Shërbimi ishte shumë i mirë dhe mikpritës", a: "Arlind B.", loc: "Tetovë" },
        { q: "Vila ishte edhe më e bukur nga sa e imagjinonim. Atmosferë fantastike", a: "Klea R.", loc: "Durrës" },
        { q: "Një vend shumë i këndshëm për t'u shkëputur nga përditshmëria. Gjithçka ishte perfekte", a: "Blerim S.", loc: "Prishtinë" }
      ],
    },
    contact: {
      eyebrow: "Rezervo",
      title: "Rezervo tani",
      desc: "Zgjidhni datat dhe do të merrni një përgjigje personale brenda 2 orëve. Për asistencë të menjëhershme, na kontaktoni në WhatsApp",
      name: "Emri juaj",
      email: "Email",
      phone: "Telefon (opsional)",
      dates: "Datat e preferuara",
      message: "Na tregoni për qëndrimin tuaj",
      send: "Dërgo Kërkesën",
      sending: "Duke dërguar…",
      success: "Faleminderit. Do të kontaktojmë së shpejti",
      error: "Diçka nuk shkoi. Ju lutem provoni përsëri",
    },
    footer: {
      tag: "Heshtja e malit, që nga 2025",
      visit: "Na vizitoni",
      address: "Jezerc, Ferizaj\nKosovë",
      contact: "Kontakt",
      email: "info@villadelightks.com",
      phone: "+383 46 323 231",
      follow: "Na ndiqni",
      rights: "© 2026 Villa Delight. Të gjitha të drejtat e rezervuara",
      crafted: "Krijuar me kujdes të qetë",
    },
  },
  EN: {
    nav: {
      home: "Home",
      villa: "The Villa",
      gallery: "Gallery",
      rooms: "Rooms",
      activities: "Experiences",
      contact: "Contact",
      book: "Book Now",
    },
    hero: {
      eyebrow: "Jezerc - Ferizaj - Kosova",
      title1: "A quiet world",
      title2: "above the clouds",
      desc: "An intimate mountain retreat wrapped in pine, stone and firelight — crafted for guests who know that true luxury is silence",
      explore: "Explore the Villa",
      book: "Reserve Your Stay",
      pay: "Pay Online",
    },
    booking: {
      checkin: "Check-in",
      checkout: "Check-out",
      guests: "Guests",
      search: "Check Availability",
      adults: (n) => `${n} ${n === 1 ? "guest" : "guests"}`,
    },
    about: {
      eyebrow: "The Sanctuary",
      title: "A hand-built Villa, carved by the mountain itself.",
      p1: "Villa Delight rises in quiet harmony from the forests of Jezerc village — a wooden retreat with low ceilings and wide windows framing alpine silence",
      p2: "Each room is designed as a pause. A place to read, to sleep without hurry, to watch the weather shift across the valley. There is a fireplace, a small library, and a terrace facing the sunrise",
      p3: "No rush. Just the mountain, a warm room, and the old habit of stillness",
      stat1: "5",
      stat1l: "Guests",
      stat2: "2",
      stat2l: "Bedrooms",
      stat3: "1,850m",
      stat3l: "Elevation",
    },
    amenities: {
      eyebrow: "What awaits you",
      title: "Considered Quiet Cared for",
      items: [
        { t: "Outdoor Swimming Pool", d: "Enjoy refreshing moments and relaxing by the pool during your stay" },
        { t: "Fireplace", d: "Indoor fireplace that creates a warm and relaxing atmosphere" },
        { t: "Modern Kitchen", d: "Stone countertops, espresso, and fresh bread daily" },
        { t: "Outdoor Grill", d: "Perfect BBQ area for cooking and dining in the open air" },
        { t: "Panoramic Terrace", d: "With views of the eastern peaks and sunrise" },
        { t: "WiFi & TV", d: "High-speed fiber internet for when you need it" },
        { t: "Private Parking", d: "Available right next to the entrance" },
        { t: "Heated Floors", d: "Installed throughout all rooms and bathrooms" },
        { t: "Air Conditioning", d: "Ensures comfort and freshness during hot days" },
      ],
    },
    gallery: {
      eyebrow: "A Visual Diary",
      title: "Linger a little longer",
    },
    rooms: {
       eyebrow: "Pricing",
       title: "Two stylishly furnished rooms with an outdoor swimming pool",
       desc: "Rates include accommodation only",
      items: [
      { name: "Private Villa with pool", size: "72 m²", guests: "Up to 5 guests", view: "Complete privacy · Exclusive stay with private", price: "€ 150" },
      ],
      night: "/ night",
      reserve: "Reserve",
    },
    activities: {
      eyebrow: "Around the Villa",
      title: "The mountain, in every season",
      items: [
      { t: "Mountal Views", d: "Breathtaking nature. Summer greenery, golden autumn colors" },
      { t: "Snow", d: "Fresh snowfall starting from December" },
      { t: "Forest", d: "Peaceful walks through ancient mountain forests" },
      { t: "Evenings at Villa Delight", d: "Unwind in the calm of the mountains, accompanied by the soothing sounds of nature" },
      ],
    },
    reviews: {
      eyebrow: "Guest Letters",
      title: "Words from those who stayed",
      items: [
        { q: "The four quietest nights of the year. We didn’t want to leave the fireplace.", a: "Ana & Lorik", loc: "Prishtina" },
        { q: "Villa Delight is a masterpiece of comfort. Every detail serves relaxation.", a: "Mark R.", loc: "Mitrovica" },
        { q: "We woke up to snow on the terrace and coffee ready. Unforgettable.", a: "Elena K.", loc: "Gjilan" },
        { q: "One of the cleanest villas we have ever visited.", a: "Onat", loc: "Gjilan" },
        { q: "Excellent service and a very relaxing place for holidays.", a: "Luan B.", loc: "Macedonia" },
        { q: "Fantastic experience, the villa was even more beautiful than in photos.", a: "Sara L.", loc: "Tirana" },
        { q: "Very clean and peaceful environment, we would definitely come back.", a: "Ardit M.", loc: "Pristina" },
      ],
    },
    contact: {
      eyebrow: "Reserve",
      title: "Begin your stay",
      desc: "Leave your dates and we will reply personally within 12 hours",
      name: "Your Name",
      email: "Email",
      phone: "Phone (optional)",
      dates: "Preferred Dates",
      message: "Tell us about your stay",
      send: "Send Request",
      sending: "Sending…",
      success: "Thank you. We will be in touch shortly",
      error: "Something went wrong. Please try again",
    },
    footer: {
      tag: "Mountain silence, since 2025",
      visit: "Visit",
      address: "Jezerc, Ferizaj\nKosovo",
      contact: "Contact",
      email: "info@villadelightks.com",
      phone: "+383 46 323 231",
      follow: "Follow",
      rights: "© 2026 Villa Delight. All rights reserved",
      crafted: "Crafted with quiet care",
    },
  },
};
